import React, { useEffect, useRef } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Form } from 'react-bootstrap'
const GetInForm = ({ errors }) => {
  const checkboxRefs = useRef([])
  const { control, watch, setValue, trigger } = useFormContext()

  const checkboxOptions = ['Someone is home', 'Doorcode', 'Hidden Key', 'Other']
  const selectedValue = watch('get_in')

  const handleCheckboxChange = (value) => {
    setValue('get_in', value === selectedValue ? null : value)
  }

  useEffect(() => {
    // Focus the first checkbox when the component mounts (if available)
    if (checkboxRefs.current[0]) {
      checkboxRefs.current[0].focus()
    }
  }, [])

  return (
    <>
      <div className="row">
        <div className="col-md-12 d-block mb-3">
          {checkboxOptions.map((option, index) => (
            <Controller
              key={index}
              name="get_in"
              control={control}
              checked={selectedValue}
              render={({ field }) => (
                <>
                  <label className="d-flex align-items-center">
                    <input
                      className="custom-checkbox m-0"
                      type="checkbox"
                      ref={(el) => (checkboxRefs.current[index] = el)}
                      checked={field.value === option}
                      onChange={() => {
                        handleCheckboxChange(option)
                        trigger('get_in')
                      }}
                    />
                    <span className="ms-3">{option}</span>
                  </label>
                </>
              )}
            />
          ))}
          <small className="fw-500">{errors?.get_in?.message}</small>{' '}
        </div>
        <div className="col-md-12">
          <div className="form-group">
            <label>
              Get-in Instruction / Door Code<span className="text-danger"> *</span>
            </label>
            <Controller
              name="get_in_instruction"
              control={control}
              render={({ field: { value, onChange }, fieldState }) => (
                <>
                  <input
                    className="form-control"
                    value={value}
                    type="text"
                    placeholder="Enter Instruction"
                    onChange={(val) => {
                      onChange(val)
                      trigger('get_in_instruction')
                    }}
                  />
                  <small>{fieldState?.error?.message}</small>
                </>
              )}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Laundry Code</label>
            <Controller
              name="laundry_code"
              control={control}
              render={({ field: { value, onChange }, fieldState }) => (
                <>
                  <input
                    className="form-control"
                    value={value}
                    type="text"
                    placeholder="Enter Laundry Code"
                    onChange={(val) => {
                      onChange(val)
                      trigger('laundry_code')
                    }}
                  />
                  <small>{fieldState?.error?.message}</small>
                </>
              )}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Storage Area Code</label>
            <Controller
              name="storage_area_code"
              control={control}
              render={({ field: { value, onChange }, fieldState }) => (
                <>
                  <input
                    className="form-control"
                    value={value}
                    type="text"
                    placeholder="Enter Storage Area Code"
                    onChange={(val) => {
                      onChange(val)
                      trigger('storage_area_code')
                    }}
                  />
                  <small>{fieldState?.error?.message}</small>
                </>
              )}
            />
          </div>
        </div>
        <div className="col-md-12">
          <Controller
            name="request_laundry"
            control={control}
            // checked={true}
            defaultValue={false}
            render={({ field }) => (
              <>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  label={`I want the cleaner to do the laundry`}
                  {...field}
                  checked={field.value} // ensures checked state is bound to value
                />
              </>
            )}
          />
        </div>
      </div>
    </>
  )
}

export default GetInForm
